export default __webpack_public_path__ + "static/media/feet.676a4068.png";